/**
 * Copyright (C) 2025 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  AlertTitle,
  Box,
  Button,
  Typography,
} from '@mui/material';
import { FlightLegUploadSuccessResponse } from '../../../store/flightLegs/reducer';
import appTheme from '../../common/theme/appTheme.json';
import { useDispatch } from 'react-redux';
import { removeFailedToParseFlightLeg } from '../../../store/flightLegs/actions';

interface FailedToParseLegsAccordionProps {
  failedToParseFlightLegs: FlightLegUploadSuccessResponse[];
}
const FailedToParseLegsAccordion = ({ failedToParseFlightLegs }: FailedToParseLegsAccordionProps) => {
  const dispatch = useDispatch();

  return (
    <Box sx={{ mt: 10 }}>
      <Accordion sx={{ border: '2px solid', borderColor: appTheme.mptPrimaryRed }}>
        <AccordionSummary
          sx={{
            alignItems: 'center',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <Typography component="span">Failed Legs ({failedToParseFlightLegs.length})</Typography>
            <Box sx={{ flex: 1 }} />
            <Button
              size="small"
              variant="text"
              sx={{ color: appTheme.mptLightBlue }}
              onClick={() => dispatch(removeFailedToParseFlightLeg(undefined, true))}
            >
              Clear All
            </Button>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          {failedToParseFlightLegs.map((leg, index) => (
            <Alert
              key={index}
              variant="outlined"
              severity="error"
              sx={{ mb: 2, bgcolor: appTheme.secondaryBackgroundColor, color: appTheme.primaryTextColor }}
              onClose={() => dispatch(removeFailedToParseFlightLeg(leg.fileName))}
            >
              <AlertTitle sx={{ fontWeight: 'bold' }}>{leg.fileName}</AlertTitle>
              {leg.error}
            </Alert>
          ))}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default FailedToParseLegsAccordion;
